import { render } from "./SaveAsCohortTemplateModal.vue?vue&type=template&id=dc9ca058"
import script from "./SaveAsCohortTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveAsCohortTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__